import { createContext, useCallback, useContext, useState } from 'react';
import { requestRemoteData } from '../API/api';

const COMERCIAL_CLIENTE_ENDPOINT = 'comercial/cliente';

const ComercialContext = createContext();

export const fetchClienteByNumCliente = (numCliente) => {
    return requestRemoteData(`${COMERCIAL_CLIENTE_ENDPOINT}/${numCliente}`);
};

export const fetchClientesComercial = () => {
    return requestRemoteData('comercial/clientes');
};

export const ComercialContextProvider = ({ children }) => {
    const [actingAsCliente, setActingAsClienteState] = useState(() => {
        const stored = sessionStorage.getItem('actingAsCliente');
        return stored ? JSON.parse(stored) : null;
    });
    // Agente (código de vendedor de BC) con el que sale el pedido, elegido junto al cliente cuando el
    // comercial tiene varios (VeterLucus: fitos por uno, farma por otro). Se vacía al cambiar de cliente.
    const [agente, setAgenteState] = useState(() => sessionStorage.getItem('comercialAgente') || null);

    const setAgente = useCallback((codigo) => {
        if (codigo) {
            sessionStorage.setItem('comercialAgente', codigo);
        } else {
            sessionStorage.removeItem('comercialAgente');
        }
        setAgenteState(codigo || null);
    }, []);

    const setActingAsCliente = useCallback((cliente) => {
        if (cliente) {
            sessionStorage.setItem('actingAsCliente', JSON.stringify(cliente));
        } else {
            sessionStorage.removeItem('actingAsCliente');
        }
        setActingAsClienteState(cliente);
        setAgente(null);
    }, [setAgente]);

    const clearActingAsCliente = useCallback(() => {
        sessionStorage.removeItem('actingAsCliente');
        setActingAsClienteState(null);
        setAgente(null);
    }, [setAgente]);

    const isComercialMode = actingAsCliente != null;

    return (
        <ComercialContext.Provider value={{ actingAsCliente, setActingAsCliente, clearActingAsCliente, isComercialMode, agente, setAgente }}>
            {children}
        </ComercialContext.Provider>
    );
};

export const useComercialContext = () => useContext(ComercialContext);
